/*
 * @Descripttion:
 * @version:
 * @Author: suiyue
 * @email: 1373842098@qq.com
 * @Date: 2022-01-12 13:49:58
 * @LastEditors: K
 * @LastEditTime: 2022-09-22 14:57:09
 */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import _ from 'lodash'
import { api, sendAsync } from '../../../app/applicationSlice'
import { RootState, RootThunk, RootThunkApi } from '../../../app/store'
import { insuranceCodeValue, MedicelListValue } from '../../../models/setting'
import * as service from '../../../services/tenentSetting'

interface tenentSettingState {
  settings: any
  insuranceArray: any
}

const initialState: tenentSettingState = {
  settings: [],
  insuranceArray: [],
}

export const saveTenentSettingLabel = createAsyncThunk<
  void,
  service.TenentSettingParams,
  RootThunkApi
>('completion/getDiseaseCompletionsStatus', async (body, api) => {
  return sendAsync(service.getTenentSettingSave(body), api)
})

export const getMedicalSettingList = createAsyncThunk<
  MedicelListValue[],
  number,
  RootThunkApi
>('completion/getMedicalSetting', async (params, api) => {
  return sendAsync(service.getMedicalSettingList(params), api)
})

export const editMedicalSetting = createAsyncThunk<
  void,
  service.MedicalSettingParams,
  RootThunkApi
>('completion/editMedicalSetting', async (body, api) => {
  return sendAsync(service.editMedicalSetting(body), api)
})

export const getSystemList = createAsyncThunk<
  insuranceCodeValue[],
  number | undefined,
  RootThunkApi
>('completion/removeMediclaSetting', async (status, api) => {
  return sendAsync(service.getSystemList(status), api)
})

export const getMedicalItem = createAsyncThunk<
  insuranceCodeValue,
  service.MedicalItemParams,
  RootThunkApi
>('completion/getMedicalItem', async (params, api) => {
  return sendAsync(service.getMedicalItem(params), api)
})

// 获取电子发票授权地址
export const getInvoiceUrl = createAsyncThunk<
  void,
  service.InvoiceUrlParams,
  RootThunkApi
>('completion/getInvoiceUrl', async (params, api) => {
  return sendAsync(service.invoiceUrl(params), api)
})
// 获取电子发票供应商
export const getInvoiceSupplierList = createAsyncThunk<
  void,
  void,
  RootThunkApi
>('completion/getInvoiceSupplierList', async (params, api) => {
  return sendAsync(service.invoiceSupplierList(), api)
})

// 回显。获取开通电子发票列表
export const invoiceDetailAsync = createAsyncThunk<
  void,
  service.InvoiceUrlParams,
  RootThunkApi
>('completion/invoiceDetailAsync', async (params, api) => {
  return sendAsync(service.invoiceDetail(params), api)
})

// 新建，修改电子发票授权机构
export const editInvoiceAsync = createAsyncThunk<
  void,
  service.EditInvoiceParams,
  RootThunkApi
>('completion/editInvoiceAsync', async (params, api) => {
  return sendAsync(service.editInvoice(params), api)
})

// 查询聚合支付（米雅）
export const getPayList = createAsyncThunk<
  void,
  string | '',
  RootThunkApi
>('completion/getPayList', async (params, api) => {
  return sendAsync(service.getPayList(params), api)
})
// 查询聚合支付（银联）
export const getPayListYinlian = createAsyncThunk<
    void,
    string | '',
    RootThunkApi
    >('completion/getPayListYinlian', async (params, api) => {
  return sendAsync(service.getPayListYinlian(params), api)
})
// 查询聚合支付（康邻）
export const getPayListKanglin = createAsyncThunk<
    void,
    string | '',
    RootThunkApi
    >('completion/getPayListKanglin', async (params, api) => {
  return sendAsync(service.getPayListKanglin(params), api)
})


// 保存聚合支付(米雅)
export const savePayList = createAsyncThunk<
  void,
  service.savePayParams,
  RootThunkApi
>('completion/savePayList', async (body, api) => {
  return sendAsync(service.savePayList(body), api)
})
// 保存聚合支付(银联)
export const savePayListYinlian = createAsyncThunk<
    void,
    service.savePayParamsYinlian,
    RootThunkApi
    >('completion/savePayListYinlian', async (body, api) => {
  return sendAsync(service.savePayListYinlian(body), api)
})
// 保存聚合支付(康邻)
export const savePayListKanglin = createAsyncThunk<
    void,
    service.savePayParamsKanglin,
    RootThunkApi
    >('completion/savePayListKanglin', async (body, api) => {
  return sendAsync(service.savePayListKanglin(body), api)
})

const tenentSettingSlice = createSlice({
  name: 'tenentSettingSlice',
  initialState,
  reducers: {
    setDetail: (state, action) => {
      state.settings = _.reduce(
        action.payload,
        (acc, { type, value }) => ({
          ...acc,
          [type]: value === 'true' ? true : value === 'false' ? false : value,
        }),
        {}
      )
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSystemList.fulfilled, (state, action) => {
      state.insuranceArray = action.payload
    })
  },
})

export function getSettingDetails(tenentId?: any): RootThunk {
  return api(service.getSettingDetail(tenentId), (data, dispatch) => {
    dispatch(setDetail(data))
  })
}

export const { setDetail } = tenentSettingSlice.actions

export const selectTenentSettings = (state: RootState): any =>
  state.tenentSetting.settings

export const selectInsuranceArray = (state: RootState): any =>
  state.tenentSetting.insuranceArray

export default tenentSettingSlice.reducer
